export const PERMISSIONS = [
  { key: "courses", label: "Courses" },
  { key: "certificates", label: "Certificates" },
  { key: "partners", label: "Partners" },
  { key: "enroll_form", label: "Enroll Form" },
  { key: "event_poster", label: "Event Poster" },
  { key: "user_event", label: "User Event" },
  { key: "being_partner", label: "Being a Partner" },
  { key: "get_in_touch_messages", label: "Contact Form" },
  { key: "iv_forms", label: "IV Forms" },
  { key: "product_details", label: "Product Details" },
  { key: "product_quotes", label: "Product Quotes" },
  { key: "quiz_scores", label: "Quiz Scores" },
  { key: "quiz_questions", label: "Quiz Questions" },
  { key: "gallery", label: "Manage Images" },
  { key: "stats", label: "Stats" },
  { key: "reviews", label: "Reviews" },
  { key: "career_applications", label: "Career Applications" },
  { key: "job_postings", label: "Job Postings" },
  { key: "franchise_applications", label: "Franchise Applications" },
  { key: "offers", label: "Offers" },
  { key: "consultations", label: "Consultation Requests" },
  { key: "about_content", label: "About Us Content" },

  // Admin management
  { key: "admin.manage", label: "Admin Manage (create admins)" },
  { key: "admin-manage", label: "Admin Maintain (view/edit admins)" },
];
